import { useEffect, useState } from 'react'
import { resolveSdk } from './utils'

export const useOsSdk = () => {
  const [loaded, setLoaded] = useState(false)
  const [ossdk, setOsSdk] = useState()
  useEffect(() => {
    resolveSdk().then((sdk) => {
      // We avoid setting ossdk again if it's already set just to avoid the concern
      // of an infinite loop if the ossdk has somehow changed. This may be unnecessary.
      if (!ossdk) {
        setOsSdk(sdk)
      }
      sdk.isReady.add(setLoaded, { now: true })
    })

    return () => {
      if (ossdk) {
        ossdk.isReady.remove(setLoaded)
      }
    }
  }, [ossdk])

  return { loaded, ossdk }
}
